import React from "react";

export default function Web_JavaScript() {
  return (
    <div>
      <h1>What is JavaScript</h1>
      <p>
        Route: <code>/web/javascript</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
